(function(){
  console.log("//----------------Custom JS Loaded---------------//");
  function init(){
    footerAccordionHandler();
    /* windowResizeHandler();
    handleProductTabsDesktop();
    handleSpamContactPage();
    initWishListSDK();
    backToTopButton();
    discountInputHandler(); */
    // window.onresize = windowResizeHandler;
  }
  function initWishListSDK(){
    console.log("Init wishlist");
    let digitalProductWishlistBtn = document.querySelector(".atc-btn__wrapper .atw-digital-btn");
    if(digitalProductWishlistBtn){
      let customerLoggedIn = digitalProductWishlistBtn.getAttribute("data-customerid");
      
      if(customerLoggedIn === "" || customerLoggedIn.length === 0){
        digitalProductWishlistBtn.addEventListener('click', function(){
          window.location.href="/account/login";
        })
      }
      
      document.addEventListener("wishlist-hero-wishlist-sdk-ready", async function (e) {
        console.log("Wishlist SDK loaded cart!"); 
        var wishlistItems = window.WishListHero_SDK.GetWishListItems();
        addWishlistItem(digitalProductWishlistBtn);
        checkItemWishlist(wishlistItems, digitalProductWishlistBtn);
      });
    }
  }

  function checkItemWishlist(wishlistItems, digitalProductWishlistBtn){
    if(digitalProductWishlistBtn){
      let productVariantId = digitalProductWishlistBtn.getAttribute("data-prod-variantid");
      console.log(productVariantId, 'productVariantId');
      if(wishlistItems.length > 0){
        let isAdded = wishlistItems.filter(wishlistItem => productVariantId === wishlistItem.ProductVariantId);
        console.log(isAdded);
        if(isAdded.length > 0){
          digitalProductWishlistBtn.innerText = "Remove From Wish List";
          digitalProductWishlistBtn.setAttribute("data-action", "remove");
          digitalProductWishlistBtn.classList.add("remove-wishlist");
        }
        else{
          digitalProductWishlistBtn.setAttribute("data-action", "add");
          digitalProductWishlistBtn.innerText = "Add To Wish List";
          digitalProductWishlistBtn.classList.remove("remove-wishlist");
        }
      }
      else{
        digitalProductWishlistBtn.setAttribute("data-action", "add");
        digitalProductWishlistBtn.innerText = "Add To Wish List";
        digitalProductWishlistBtn.classList.remove("remove-wishlist");
        
      }
    }    
  }

  function addWishlistItem(digitalProductWishlistBtn){
    if(digitalProductWishlistBtn){
      digitalProductWishlistBtn.addEventListener("click", async function(){
        console.log("Hello there!");
        let btnAction = this.getAttribute("data-action");
        
        var productInfo = btnAction === "add" ? {
          CustomerId: this.getAttribute("data-customerid"),
          ProductId: this.getAttribute("data-prodid"),
          ProductTitle: this.getAttribute("data-prod-title"),
          ProductPrice: this.getAttribute("data-prod-price"),
          ProductLink: this.getAttribute("data-customerid"),
          ProductVariantId: this.getAttribute("data-prod-variantid"),
          ProductImage: this.getAttribute("data-prod-image"),
          WishlistHash: window.WishListHero_SDK.GetWishListHash()
        } : {
          ProductVariantId: this.getAttribute("data-prod-variantid"),
          WishlistHash: window.WishListHero_SDK.GetWishListHash()
        };
        
        var response = btnAction === "add" ? await window.WishListHero_SDK.AddWishListItem(productInfo) : await window.WishListHero_SDK.DeleteWishListItem(productInfo);
        console.log(response);
        if(response.status === 200 && response.ok){
          // window.location.href="/a/wishlist-hero/wishlist";
          if(btnAction === "add"){
            this.setAttribute("data-action", "remove");
            this.innerText = "Remove From Wish List";
            this.classList.add("remove-wishlist");
          }
          else{
            this.setAttribute("data-action", "add");
            this.innerText = "Add To Wish List";
            this.classList.remove("remove-wishlist");          
          }
        }
      }); 
    }
  }
  
  /* --------- HANDLE PREDICTIVE SEARCH LOADER ----------*/
  
  function searchLoaderHandler(){
    let searchLoader = document.querySelector('.predictive-search__loading-state');
    // searchLoader.style.display = 'none';
    setTimeout(()=>{
      searchLoader.style.display = 'block';
    }, 2500);
  }

  /* --------- HANDLE FOOTER ACCORDION MOBILE ----------*/
  
  function footerAccordionHandler(){
    
    let footerBlocks = document.querySelectorAll('.ced-accordion');
    footerBlocks.forEach((footerBlock)=>{
      let screenWidth = screen.width;
      if(screenWidth < 750){
        let content = footerBlock.nextElementSibling;
        content.classList.add('hide-content');
      }
    });
    // console.log(footerBlocks);
    footerBlocks.forEach((footerBlock) => {
      footerBlock.addEventListener('click', function(){
        let screenWidth = screen.width;
        if(screenWidth < 750){
          let content = this.nextElementSibling;
          this.classList.toggle('inactive');
          content.classList.toggle('hide-content');
        }
      });
    });
  }

  /* --------- HANDLE PRODUCT TABS, SEARCH LABEL ON WINDOW RESIZE EVENT ----------*/
  
  function windowResizeHandler(){
    let screenWidth = screen.width;
    let searchLabel = document.querySelector('.search-modal__form #search-label');
    let desktopTabWrappers = document.querySelectorAll('[data-screen="desktop"]');
    let mobileTabWrappers = document.querySelectorAll('[data-screen="mobile"]');

    if(screenWidth < 540){
      searchLabel.innerText = "Search";
    }
    else{
      searchLabel.innerText = "Type Slowly to Engage Auto Suggestions";
    }
    
    if(screenWidth <= 640){
      desktopTabWrappers.forEach((desktopTab)=>{
        desktopTab.removeAttribute('id');
        desktopTab.classList.remove('tab-description-wrapper');
        // desktopTab.style.display = "none";
        desktopTab.classList.add("tab-hide")
      });

      mobileTabWrappers.forEach((mobileTab, index)=>{
        mobileTab.classList.remove("tab-hide");
        mobileTab.setAttribute('id', mobileTab.getAttribute('data-tabid'));
        mobileTab.classList.add('tab-description-wrapper');
        console.log(mobileTab.parentElement);
        index === 0 ? mobileTab.classList.add("tab-show") : mobileTab.classList.add("tab-hide");
        // index === 0 ? mobileTab.style.display = "block" : mobileTab.style.display = "none";
        index === 0 ? mobileTab.parentElement.classList.add("active") : mobileTab.parentElement.classList.remove("active");
      });
    }
    else{
      mobileTabWrappers.forEach((mobileTab)=>{
        mobileTab.removeAttribute('id');
        mobileTab.classList.remove('tab-description-wrapper');
        // mobileTab.style.display = "none";
        mobileTab.classList.add("tab-hide")
      });
      
      desktopTabWrappers.forEach((desktopTab, index)=>{
        desktopTab.classList.remove("tab-hide");
        desktopTab.setAttribute('id', desktopTab.getAttribute('data-tabid'));
        desktopTab.classList.add('tab-description-wrapper');
        index === 0 ? desktopTab.classList.add("tab-show") : desktopTab.classList.add("tab-hide");
        // index === 0 ? desktopTab.style.display = "block" : desktopTab.style.display = "none";
      });
    }
  }

  /* --------- HANDLE PRODUCT TABS ON PRODUCT PAGE ----------*/

  function handleProductTabsDesktop(){
    let tabBtns = document.querySelectorAll('.tab-wrapper a.tab-btn');

    if(tabBtns.length > 0){
      tabBtns.forEach((tabBtn)=>{
        tabBtn.addEventListener('click', function(event){
          event.preventDefault();
          let screenWidth = screen.width;
          let descriptionId = this.getAttribute('href');
          let descriptionWrappers = document.querySelectorAll('.tab-description-wrapper');
          let tabList = document.querySelectorAll('.tab-wrapper li');

          if(screenWidth > 640){
            descriptionWrappers.forEach((descriptionWrapper)=>{
              descriptionWrapper.classList.add('tab-hide');  
              descriptionWrapper.classList.remove('tab-show');
              // descriptionWrapper.style.display = "none";
            });
            
            tabList.forEach((list) => {
              list.classList.remove('active');
            });
            document.querySelector(`${descriptionId}`).classList.remove("tab-hide");
            document.querySelector(`${descriptionId}`).classList.add("tab-show");
            
            this.parentElement.classList.add('active');
          }
          else{
            document.querySelector(`${descriptionId}`).classList.toggle("tab-show");
            document.querySelector(`${descriptionId}`).classList.toggle("tab-hide");
            this.parentElement.classList.toggle('active');
          }
          
          
          // if(document.querySelector(`${descriptionId}`).classList.contains("tab-show")){
          //   document.querySelector(`${descriptionId}`).classList.toggle("tab-hide");
          // }
          // else{
          //   document.querySelector(`${descriptionId}`).classList.toggle("tab-show");
          // }
          // // document.querySelector(`${descriptionId}`).classList.toggle("tab-show");
          // // document.querySelector(`${descriptionId}`).classList.toggle("tab-hide");
          // this.parentElement.classList.toggle('active');
        });
      });
    }
  }

  /* --------- HANDLE SPAM CALCULATION ON CONTACT PAGE ----------*/

  function handleSpamContactPage(){
    let spamLabel = document.querySelector('#ContactForm [for="ContactForm-spam"]');
    if(spamLabel){
      let firstRandomNumber = Math.floor(Math.random() * 10);
      let secondRandomNumber = Math.floor(Math.random() * 10);
      let spamInput = document.querySelector('[name="contact[spam]"]');
      let updatedLabelText = `S P A M challenge? ${firstRandomNumber} + ${secondRandomNumber} = `;
  
      spamLabel.innerText = updatedLabelText;
      spamInput.setAttribute("data-num1", firstRandomNumber);
      spamInput.setAttribute("data-num2", secondRandomNumber); 
    } 
  }

  function backToTopButton(){
    let scrollBtnWrapper = document.querySelector(".backtoTop-wrapper");
    let scrollBtn = document.querySelector(".backtoTop-wrapper .btn");
    let bodyElement = document.querySelector("body");

    let lastKnownScrollPosition = window.scrollY;
    if(lastKnownScrollPosition < 300){
      scrollBtnWrapper.style.display = "none";
    }
    else{
      scrollBtnWrapper.style.display = "block";
    }

    document.addEventListener("scroll", function(event){
      let lastKnownScrollPosition = window.scrollY;
      if(lastKnownScrollPosition < 300){
        scrollBtnWrapper.style.display = "none";
      }
      else{
        scrollBtnWrapper.style.display = "block";
      }
    });
    scrollBtn.addEventListener("click", function(){
      document.querySelector("html").style.scrollBehaviour = "smooth";
      scrollToTop(1500);
      // window.scrollTo(0,0);
    });
  }


  function scrollToTop (duration) {
    if (document.scrollingElement.scrollTop === 0) return;

    const totalScrollDistance = document.scrollingElement.scrollTop;
    let scrollY = totalScrollDistance, oldTimestamp = null;

    function step (newTimestamp) {
        if (oldTimestamp !== null) {
            scrollY -= totalScrollDistance * (newTimestamp - oldTimestamp) / duration;
            if (scrollY <= 0) return document.scrollingElement.scrollTop = 0;
            document.scrollingElement.scrollTop = scrollY;
        }
        oldTimestamp = newTimestamp;
        window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }

  function discountInputHandler(){
    let discountBtn = document.querySelector(".Redeem-btn");
    let discountModal = document.querySelector(".main-discount__wrapper");

    if(discountBtn){
      discountBtn.addEventListener('click', function(){
        if(discountModal){
          discountModal.classList.toggle("hidden");
          if (discountModal.style.maxHeight) {
            discountModal.style.maxHeight = null;
          } else {
            discountModal.style.maxHeight = discountModal.scrollHeight + "px";
          }
        }
        console.log("clicked");
      }); 
    }
  }

  init();
})();